var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { StringLifeStatusClient, CompaniesClient, SitesClient, ReportScheduleModel, GetStringLifeStatusQuery, BatteryTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const stringStatusClient = new StringLifeStatusClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let StringStatusReportFilterVue = class StringStatusReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.companies = [];
        this.sites = [];
        this.batteryTypes = [
            { value: BatteryTypeEnum.LeadAcid, text: "Lead-Acid" },
            { value: BatteryTypeEnum.Lithium, text: "Lithium" },
        ];
        this.query = new GetStringLifeStatusQuery();
    }
    created() {
        this.getLookups();
    }
    ;
    mounted() {
        this.loadReportScheduleQuery();
        if (!this.query.batteryType)
            this.query.batteryType = BatteryTypeEnum.LeadAcid;
    }
    ;
    setDefaultValues() {
        if (this.working)
            return;
        if (this.query.batteryType == BatteryTypeEnum.LeadAcid) {
            this.query.ohmicRiseColumn1 = 10;
            this.query.ohmicRiseColumn2 = 20;
            this.query.ohmicRiseColumn3 = 30;
            this.query.ohmicRiseColumn4 = 40;
        }
        else {
            this.query.ohmicRiseColumn1 = 70;
            this.query.ohmicRiseColumn2 = 80;
            this.query.ohmicRiseColumn3 = 90;
        }
        this.setValueFields();
    }
    setValueFields() {
        this.setFieldValue("ohmicRiseColumn1", this.query.ohmicRiseColumn1);
        this.setFieldValue("ohmicRiseColumn2", this.query.ohmicRiseColumn2);
        this.setFieldValue("ohmicRiseColumn3", this.query.ohmicRiseColumn3);
        this.setFieldValue("ohmicRiseColumn4", this.query.ohmicRiseColumn4);
    }
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (!this.validateSettings())
            return null;
        this.query.timezoneOffset = moment().utcOffset();
        return this.query;
    }
    ;
    validateSettings() {
        if (Number(this.query.ohmicRiseColumn1) >= Number(this.query.ohmicRiseColumn2)) {
            Notifier.onWarning("Lower Range cannot be greater than or equal Lower Middle Range!");
            return false;
        }
        if (Number(this.query.ohmicRiseColumn2) >= Number(this.query.ohmicRiseColumn3)) {
            Notifier.onWarning("Lower Middle Range cannot be greater than or equal Upper Middle Range!");
            return false;
        }
        if (this.query.batteryType == BatteryTypeEnum.LeadAcid && Number(this.query.ohmicRiseColumn3) >= Number(this.query.ohmicRiseColumn4)) {
            Notifier.onWarning("Upper Middle Range cannot be greater than or equal Upper Range!");
            return false;
        }
        return true;
    }
    exportToPdf() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            stringStatusClient.downloadStringStatusReportAsPDF(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                let blob = new Blob([response.data], { type: 'application/pdf;base64' });
                let url = URL.createObjectURL(blob);
                var popUp = window.open(url, '_blank');
                if (popUp == null || typeof (popUp) == 'undefined') {
                    alert('Please disable your pop-up blocker and try again.');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    exportToCsv() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            stringStatusClient.downloadStringStatusReportAsCsv(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                DownloadUtil.handleFileDownload(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    ;
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery(false);
    }
    ;
    onCompanyIdChanged() {
        if (!this.working)
            this.query.siteId = null;
    }
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    ;
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        console.log("reportScheduledModel", this.reportScheduledModel);
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            this.working = true;
            var query = JSON.parse(queryString);
            this.query.companyId = query.companyId;
            this.query.siteId = query.siteId;
            this.query.batteryType = query.batteryType;
            this.query.ohmicRiseColumn1 = query.ohmicRiseColumn1;
            this.query.ohmicRiseColumn2 = query.ohmicRiseColumn2;
            this.query.ohmicRiseColumn3 = query.ohmicRiseColumn3;
            this.query.ohmicRiseColumn4 = query.ohmicRiseColumn4;
            this.setValueFields();
            this.$nextTick(() => {
                this.working = false;
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.query.companyId || site.companyId == this.query.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get batteryType() {
        return this.batteryTypes.filter(item => {
            return item.value == this.query.batteryType;
        })[0] || null;
    }
    ;
    set batteryType(item) {
        if (!item)
            return;
        this.query.batteryType = item.value;
    }
    ;
    get getSettingsTitle() {
        return this.query.batteryType == BatteryTypeEnum.LeadAcid ? 'Ohmic Rise (%)' : 'SOH (%)';
    }
    get column2Label() {
        return this.query.batteryType == BatteryTypeEnum.LeadAcid ? 'Lower Middle Range' : 'Middle Range';
    }
    get column3Label() {
        return this.query.batteryType == BatteryTypeEnum.LeadAcid ? 'Upper Middle Range' : 'Upper Range';
    }
    get isLeadAcid() {
        return this.query.batteryType == BatteryTypeEnum.LeadAcid;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], StringStatusReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch('query.batteryType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringStatusReportFilterVue.prototype, "setDefaultValues", null);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringStatusReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringStatusReportFilterVue.prototype, "onCompanyIdChanged", null);
StringStatusReportFilterVue = __decorate([
    Component({
        name: "StringStatusReportFilterVue",
        emits: ["schedule", "updateSchedule"],
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue } = useForm({
                validationSchema: yup.object({
                    ohmicRiseColumn1: yup.number().integer().min(0).max(100),
                    ohmicRiseColumn2: yup.number().integer().min(0).max(100),
                    ohmicRiseColumn3: yup.number().integer().min(0).max(100),
                    ohmicRiseColumn4: yup.number().integer().min(0).max(100),
                })
            });
            const ohmicRiseColumn1Val = defineInputBinds('ohmicRiseColumn1');
            const ohmicRiseColumn2Val = defineInputBinds('ohmicRiseColumn2');
            const ohmicRiseColumn3Val = defineInputBinds('ohmicRiseColumn3');
            const ohmicRiseColumn4Val = defineInputBinds('ohmicRiseColumn4');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                ohmicRiseColumn1Val,
                ohmicRiseColumn2Val,
                ohmicRiseColumn3Val,
                ohmicRiseColumn4Val,
            };
        }
    })
], StringStatusReportFilterVue);
export default StringStatusReportFilterVue;
